import { render, staticRenderFns } from "./ProductAddToCart.vue?vue&type=template&id=6a8a4b1e"
import script from "./ProductAddToCart.vue?vue&type=script&lang=js"
export * from "./ProductAddToCart.vue?vue&type=script&lang=js"
import style0 from "./ProductAddToCart.vue?vue&type=style&index=0&id=6a8a4b1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports